import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ParityManagerEscalationinfo } from 'lumen/models';
import ParityManagerStat from 'lumen/models/parity-manager/stat';

interface IssueMeta {
  brand_code?: string;
  name: string;
}

export default class ParityManagerIssuesummary extends ParityManagerStat {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-manager/issuesummary' as const;

  @belongsTo('parity-manager/escalationinfo', {
    async: false,
    inverse: 'subscriptionId',
  })
  declare escalationinfo: ParityManagerEscalationinfo;

  @attr('number') declare amountIssues: number;
  @attr() declare meta: IssueMeta;

  get formattedName(): string {
    const nameWithCapital =
      this.meta.name.charAt(0).toUpperCase() + this.meta.name.slice(1);
    return this.meta.brand_code
      ? `${nameWithCapital} (${this.meta.brand_code})`
      : nameWithCapital;
  }
}
